// Edição das regras do salão: cada mudança salva com a versão atual; se alguém salvou antes,
// busca a versão nova e aplica a mudança por cima (nunca sobrescreve sem saber).
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api, ApiError } from '../api.ts';
import { msg } from '../app/actions.ts';
import { useToast } from '../app/toast.tsx';
import type { Settings } from './data.ts';

interface SettingsDoc { version: number; settings: Settings; defaults?: { messages: Settings['messages'] } }

export function useSettingsEdit() {
  const qc = useQueryClient();
  const toast = useToast();
  const q = useQuery({ queryKey: ['settings'], queryFn: () => api.get<SettingsDoc>('/settings') });
  const [savedAt, setSavedAt] = useState(0);
  async function save(change: (s: Settings) => Settings) {
    const cur = q.data;
    if (!cur) return;
    const put = (v: { version: number; settings: Settings }) => api.put<{ version: number; settings: Settings }>('/settings', { version: v.version, settings: change(structuredClone(v.settings)) });
    try {
      let r;
      try { r = await put(cur); } catch (e) {
        if (!(e instanceof ApiError && e.code === 'STALE')) throw e;
        r = await put(await api.get<SettingsDoc>('/settings'));
      }
      qc.setQueryData(['settings'], { ...r, defaults: cur.defaults });
      await qc.invalidateQueries({ queryKey: ['me'] });
      setSavedAt(Date.now());
    } catch (e) { toast(msg(e), 'warn'); }
  }
  return { settings: q.data?.settings, defaults: q.data?.defaults, save, savedAt, loading: q.isLoading };
}
